import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button,
  Timespanpicker
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import {Timepicker} from 'react-timepicker';
import 'react-timepicker/timepicker.css';

// import TextField from '@mui/material/TextField';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    let myCompany = null;
    if (this.props.myCompany) {
      myCompany = this.props.myCompany;
    } else {
      myCompany = (this.props.mainState && this.props.mainState.myCompany) ? this.props.mainState.myCompany : null;
    }

    let myCompanyWorkplaces = null;
    if (this.props.myCompanyWorkplaces) {
      myCompanyWorkplaces = this.props.myCompanyWorkplaces;
    } else {
      myCompanyWorkplaces = (myCompany && this.props.mainState.myCompanyWorkplaces && this.props.mainState.myCompanyWorkplaces[myCompany.uuid]) ? this.props.mainState.myCompanyWorkplaces[myCompany.uuid] : null;
    }

    let myEmployees = null;
    if (this.props.myEmployees) {
      myEmployees = this.props.myEmployees;
    } else {
      myEmployees = (myCompany && this.props.mainState.myEmployees && this.props.mainState.myEmployees[myCompany.uuid]) ? this.props.mainState.myEmployees[myCompany.uuid] : null;
    }

    this.state = {
      myCompany: myCompany,
      myCompanyWorkplaces: myCompanyWorkplaces,
      myEmployees: myEmployees,
      servicesSize: "auto"
    };

    this.createMyCompanyCard.bind(this);
    this.createCompanyCardContent(this);
    this.createMyEmployeesCard.bind(this);
    this.handleMyCompanyFieldChange.bind(this);
    this.handleNewWorkplaceFieldChange.bind(this);
    this.handleEntityFieldChange.bind(this);
    this.loadMyCompany.bind(this);
    this.loadMyCompanyWorkplaces.bind(this);
    this.loadMyEmployees.bind(this);
    this.saveMyCompany.bind(this);
    this.buildWorkplaces.bind(this);
    this.deleteWorkplace.bind(this);

    // let externalUsers = [
    //   "Oniti"
    // ];
    // if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
    //   this.props.history.push("/clientes");
    // }
  }
  componentDidMount() {
    this.loadMyCompany();
    // this.loadMyEmployees();
  }
  componentWillUnmount() {
    this.props.saveMyCompany(this.state.myCompany);
    this.props.saveMyCompanyWorkplaces(this.state.myCompanyWorkplaces);
    this.props.saveMyEmployees(this.state.myEmployees);
  }
  async loadMyCompany() {
    this.setState({ isLoadingMyCompany: true });
    this.props.loadMyCompany().then(result => {
      this.setState({
        isLoadingMyCompany: false,
        myCompany: result.ok ? result.company : null
      });
      if (result.ok) {
        this.loadMyCompanyWorkplaces(result.company.uuid);
        this.loadMyEmployees(result.company.uuid);
      } else {
        this.setState({ myCompanyWorkplaces: [] });
      }
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyCompanyWorkplaces(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyCompanyWorkplaces: true });
    this.props.loadMyCompanyWorkplaces(company_id).then(result => {
      this.setState({
        isLoadingMyCompanyWorkplaces: false,
        myCompanyWorkplaces: result.ok ? result.workplaces : []
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al cargar los centros de trabajo de mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async loadMyEmployees(company_id) {
    if (!company_id) company_id = this.state.myCompany.uuid;
    this.setState({ isLoadingMyEmployees: true });
    this.props.loadMyEmployees(company_id).then(result => {
      this.setState({
        isLoadingMyEmployees: false,
        myEmployees: result.ok ? result.employees : null
      });
      if (!result.ok) {
        this.setState({ myEmployees: [] });
      }
    })
    .catch((error) => {
      this.setState({
        isLoadingMyEmployees: false,
      });
      // Error 😨
      console.log("Error al cargar mis empleados: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveMyCompany() {
    this.setState({
      createCompany: false,
      isSavingMyCompany: true
    });
    this.props.saveMyCompany(this.state.myCompany).then(result => {
      this.setState({
        isSavingMyCompany: false,
        myCompany: result.ok ? result.company : null
      });
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveWorkplace(workplace) {
    console.log("workplace", workplace);
    if (!workplace) return;
    this.setState({
      createWorkplace: false,
      editWorkplace: false,
      isSavingWorkplace: true
    });
    workplace = workplace || this.state.newWorkplace;
    workplace.company = this.state.myCompany.uuid;
    workplace = {
      id: workplace.id || null,
      name: workplace.workplaceName,
      street: workplace.workplaceStreet,
      postal_code: workplace.workplacePostalCode,
      locality: workplace.workplaceLocality,
      company: workplace.company
    };
    if (workplace.id) {
      let editingWorkplace = this.state.editingWorkplace;
      if (!editingWorkplace) editingWorkplace = [];
      editingWorkplace[workplace.id] = true;
      this.setState({
        editingWorkplace: editingWorkplace
      });
    } else {
      let workplaces = this.state.myCompanyWorkplaces;
      if (!workplaces) workplaces = [];
      workplace.isNew = true;
      workplaces["new"] = workplace;
    }
    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.saveWorkplace(workplace).then(result => {
      this.setState({
        isSavingWorkplace: false,
        newWorkplace: null
      });
      if (workplace.id) {
        let editingWorkplace = this.state.editingWorkplace;
        if (!editingWorkplace) editingWorkplace = [];
        editingWorkplace[workplace.id] = false;
        this.setState({
          editingWorkplace: editingWorkplace
        });
      }
      this.loadMyCompanyWorkplaces();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empresa: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async saveEmployee(employee) {
    this.setState({
      createEmployee: false,
      editEmployee: false,
      isSavingMyEmployee: true
    });
    employee = employee || this.state.newEmployee;
    employee.company = this.state.myCompany.uuid;
    // employee = {
    //   id: employee.id || null,
    //   name: employee.workplaceName,
    //   street: workplace.workplaceStreet,
    //   postal_code: workplace.workplacePostalCode,
    //   locality: workplace.workplaceLocality,
    //   company: workplace.company
    // };
    if (employee.id) {
      let editingEmployee = this.state.editingEmployee;
      if (!editingEmployee) editingEmployee = [];
      editingEmployee[employee.id] = true;
      this.setState({
        editingEmployee: editingEmployee
      });
    } else {
      let employees = this.state.myEmployees;
      if (!employees) employees = [];
      employee.isNew = true;
      employees["new"] = employee;
    }
    // return;
    this.props.saveEmployee(employee).then(result => {
      this.setState({
        isSavingMyEmployee: false,
        newEmployee: null
      });
      if (employee.id) {
        let editingEmployee = this.state.editingEmployee;
        if (!editingEmployee) editingEmployee = [];
        editingEmployee[employee.id] = false;
        this.setState({
          editingEmployee: editingEmployee
        });
      }
      this.loadMyEmployees();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al guardar mi empleado: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async generateLearnUrl(uuid) {
    if (this.state.isGeneratingLearnUrl) return;
    this.setState({
      isGeneratingLearnUrl: true
    });
    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.generateLearnUrl(uuid).then(result => {
      this.setState({
        isGeneratingLearnUrl: false
      });
      if (result.ok) {
        let learnUrls = this.state.learnUrls;
        if (!learnUrls) learnUrls = [];
        learnUrls[uuid] = result.url;
        this.setState({ learnUrls: learnUrls });
      }
    })
    .catch((error) => {
      this.setState({
        isGeneratingLearnUrl: false
      });
      // Error 😨
      console.log("Error al guardar mi empleado: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  async deleteWorkplace(workplace) {
    if (!workplace) return;
    let deletingWorplace = this.state.deletingWorplace;
    if (!deletingWorplace) deletingWorplace = [];
    if (deletingWorplace[workplace]) return;
    deletingWorplace[workplace] = true;
    this.setState({ deletingWorplace: deletingWorplace });

    // console.log("saveWorkplace:", workplace);
    // return;
    this.props.deleteWorkplace(workplace).then(result => {
      deletingWorplace = this.state.deletingWorplace;
      deletingWorplace[workplace] = false;
      this.setState({ deletingWorplace: deletingWorplace });
      if (result.ok) {
        workplace = result.workplace;
        let workplaces = this.state.myCompanyWorkplaces;
        workplaces[workplace.id] = workplace;
        this.setState({ workplaces: workplaces });
      }
      this.loadMyCompanyWorkplaces();
    })
    .catch((error) => {
      // Error 😨
      console.log("Error al eliminar el centro de trabajo: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  handleMyCompanyFieldChange(field, value) {
    this.handleEntityFieldChange("myCompany", field, value);
    // let myCompany = this.state.myCompany;
    // if (!myCompany) myCompany = {};
    // myCompany[field] = value;
    // this.setState({ myCompany: myCompany });
  }
  handleNewWorkplaceFieldChange(field, value) {
    this.handleEntityFieldChange("newWorkplace", field, value);
    // let newWorkplace = this.state.newWorkplace;
    // if (!newWorkplace) newWorkplace = {};
    // newWorkplace[field] = value;
    // this.setState({ newWorkplace: newWorkplace });
  }
  handleEntityFieldChange(entity_name, field, value) {
    let entity = this.state[entity_name];
    if (!entity) entity = {};
    entity[field] = value;
    this.setState({ [entity_name]: entity });
  }
  buildWorkplaces() {
    let content = null;
    if (this.state.isLoadingMyCompanyWorkplaces && !this.state.myCompanyWorkplaces) {
      content = (
        <Col xs={12} md={12}>
          <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
        </Col>
      );
    } else {
      if (this.state.createWorkplace || this.state.editWorkplace) {
        let newWorkplace = this.state.newWorkplace;
        if(!newWorkplace) newWorkplace = {}; 
        let workplaceName = (newWorkplace && newWorkplace.workplaceName) ? newWorkplace.workplaceName : "";
        let workplaceStreet = (newWorkplace && newWorkplace.workplaceStreet) ? newWorkplace.workplaceStreet : "";
        let workplaceLocality = (newWorkplace && newWorkplace.workplaceLocality) ? newWorkplace.workplaceLocality : "";
        let workplacePostalCode = (newWorkplace && newWorkplace.workplacePostalCode) ? newWorkplace.workplacePostalCode : "";
        content = (
          <Row className="text-left workplace-info new-workplace">
            <Col xs={12} md={12}>
              <CardHeader>
                <b>
                  {newWorkplace.isNew ? (<span><i className="now-ui-icons ui-1_simple-add" /> Nuevo centro</span>) : (<span><i className="fa fa-edit" /> Editar centro</span>)}
                </b>
              </CardHeader>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Nombre</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="workplaceName"
                  placeholder="Oficina central"
                  value={workplaceName}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplaceName", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Calle</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="workplaceStreet"
                  placeholder="Paseo Delicias 24"
                  value={workplaceStreet}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplaceStreet", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Localidad</Label>
              <FormGroup>
                <Input
                  type="text"
                  name="workplaceLocality"
                  placeholder="Madrid"
                  value={workplaceLocality}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplaceLocality", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={12} md={12}>
              <Label md={3}>Código postal</Label>
              <FormGroup>
                <Input
                  type="number"
                  name="workplacePostalCode"
                  placeholder="28014"
                  value={workplacePostalCode}
                  onChange={event =>
                    this.handleNewWorkplaceFieldChange("workplacePostalCode", event.target.value)
                  }
                />
              </FormGroup>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="success" 
                size="sm"
                onClick={() => {
                  this.saveWorkplace(this.state.newWorkplace);
                  // this.setState({ createCompany: false });
                }}
                >
                Guardar
              </Button>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="default" 
                size="sm"
                onClick={() => {
                  this.setState({
                    createWorkplace: false,
                    newWorkplace: null,
                    editWorkplace: null
                  });
                }}
                >
                Cancelar
              </Button>
            </Col>
          </Row>
        );
      } else {
        if (this.state.myCompanyWorkplaces && Object.keys(this.state.myCompanyWorkplaces).length > 0) {
          let workplaces = [];
          let workplacesIds = Object.keys(this.state.myCompanyWorkplaces);
          let size = workplacesIds.length;
          if (size > 2) {
            size = {
              xs: 12,
              md: 4,
              lg: 4,
              xl: 4
            };
          } else {
            size = {
              xs: 12,
              md: 4,
              lg: 4,
              xl: 4
            };
          }
          workplacesIds.map(workplaceId => {
            let workplace = this.state.myCompanyWorkplaces[workplaceId];
            let bodyContent = null;
            let specialColor = false;
            if (workplace.isNew) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Creando</span>;
              specialColor = true;
            } else if (this.state.editingWorkplace && this.state.editingWorkplace[workplaceId]) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Guardando</span>;
              specialColor = true;
            } else {
              bodyContent = workplace.street + ", " + workplace.locality + " (" + workplace.postal_code + ")";
            }
            let options = null;
            if (this.state.openOptions === workplaceId) {
              bodyContent = (
                <Row id="edit-workplace-buttons">
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          editWorkplace: workplace.id,
                          openOptions: null,
                          newWorkplace: {
                            id: workplace.id,
                            workplaceName: workplace.name,
                            workplaceStreet: workplace.street,
                            workplaceLocality: workplace.locality,
                            workplacePostalCode: workplace.postal_code
                          }
                        });
                      }}
                      color="primary"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyCompany}
                    >
                      <i className="fa fa-edit" /> Editar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.deleteWorkplace(workplace.id);
                        this.setState({
                          openOptions: null
                        });
                      }}
                      color="danger"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyCompany}
                    >
                      <i className="fa fa-trash" /> Eliminar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                </Row>
              );
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptions: null
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="now-ui-icons ui-1_simple-remove" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            } else {
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptions: workplace.id
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="fa fa-ellipsis-v" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            }
            workplaces.push(
              <Col {...size} key={workplace.id}>
                <Card className={"workplace-info card-stats plain " + (specialColor ? "workplace-editing" : "")}>
                  <CardHeader>
                    <b>
                      <i className="fa fa-building" /> {workplace.name}
                    </b>
                    {options}
                  </CardHeader>
                    <CardBody>{bodyContent}</CardBody>
                </Card>
              </Col>
            );
          });
          content = <Row>{workplaces}</Row>;
        } else {
          content = (
            <Row>
              <Col xs={12} md={12}>
                No hay centros
                <Button 
                  block 
                  color="primary" 
                  size="sm"
                  disabled={this.state.isSavingWorkplace}
                  onClick={() => {
                    this.setState({
                      newWorkplace: {
                        isNew: true
                      },
                      createWorkplace: true
                    });
                  }}
                  >
                  {!this.state.isSavingWorkplace ?
                    (<span><i className="now-ui-icons ui-1_simple-add" /> Añadir centro</span>) :
                    (<span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Añadiendo</span>)
                  }
                </Button>
              </Col>
            </Row>
          );
        }
      }
    }
    let card = (
      <Col xs={12}>
        <Card className="my-company-workplaces-info card-stats plain">
          <CardHeader>
            <b>
              <i className="fa fa-building" /> Centros de trabajo
            </b>
            {(this.state.myCompanyWorkplaces && !this.state.createWorkplace) && <div className="corner-action-icon">
                <Button
                  onClick={() => {
                    this.setState({
                      newWorkplace: { isNew: true },
                      createWorkplace: true
                    });
                  }}
                  color="primary"
                  size="sm"
                  round
                  icon
                  disabled={this.state.isSavingMyCompany}
                >
                  <i className="now-ui-icons ui-1_simple-add" />
                  {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                </Button>
              </div>
            }
          </CardHeader>
          <CardBody>
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  createCompanyCardContent() {
    let content = null;
    if (this.state.isLoadingMyCompany && !this.state.myCompany) {
      content = (
        <Row className="text-center">
          <Col xs={12} md={12}>
            <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
          </Col>
        </Row>
      );
    } else if (this.state.createCompany) {
      let companyNif = (this.state.myCompany && this.state.myCompany.nif) ? this.state.myCompany.nif : "";
      let companyName = (this.state.myCompany && this.state.myCompany.name) ? this.state.myCompany.name : "";
      content = (
        <Row className="text-left">
          <Col xs={12} md={12}>
            <Label md={3}>NIF</Label>
            <FormGroup>
              <Input
                type="text"
                name="companyNIF"
                placeholder="NIF de la empresa"
                value={companyNif}
                onChange={event =>
                  this.handleMyCompanyFieldChange("nif", event.target.value)
                }
              />
            </FormGroup>
          </Col>
          <Col xs={12} md={12}>
            <Label md={3}>Nombre legal</Label>
            <FormGroup>
              <Input
                type="text"
                name="companyName"
                placeholder="Empresa SL"
                value={companyName}
                onChange={event =>
                  this.handleMyCompanyFieldChange("name", event.target.value)
                }
              />
            </FormGroup>
          </Col>
          <Col xs={6}>
            <Button 
              block 
              color="success" 
              size="sm"
              onClick={() => {
                this.saveMyCompany();
                // this.setState({ createCompany: false });
              }}
              >
              Guardar
            </Button>
          </Col>
          <Col xs={6}>
            <Button 
              block 
              color="default" 
              size="sm"
              onClick={() => {
                this.setState({
                  createCompany: false,
                  myCompany: JSON.parse(this.state.myCompanyBefore)
                });
              }}
              >
              Cancelar
            </Button>
          </Col>
        </Row>
      );
    } else if (!this.state.myCompany) {
      content = (
        <Row className="text-center">
          <Col xs={12} md={12}>
            No hay información
          </Col>
          <Col xs={12} md={12}>
            <Button 
              block 
              color="primary" 
              size="sm"
              onClick={() => {
                this.setState({
                  myCompanyBefore: JSON.stringify(this.state.myCompany),
                  createCompany: true
                });
              }}
              >
              <i className="now-ui-icons ui-1_simple-add" /> Añadir empresa
            </Button>
          </Col>
        </Row>
      );
    } else {
      content = (
        <Row className="text-center">
          <Col xs={12} md={12}>
            <CardTitle>{this.state.myCompany.name}</CardTitle>
          </Col>
          <Col xs={12} md={12}>
            {this.state.myCompany.nif}
          </Col>
        </Row>
      );
    }
    return content;
  }
  createMyCompanyCard() {
    let card = null;
    let content = this.createCompanyCardContent();

    card = (
      <div 
        id="my-company-info" 
        className="card-stats card-raised text-white"
        color="default"
        >
        <CardHeader className="text-center">
          <i className="fa fa-university"></i> Mi empresa
          {(this.state.myCompany && !this.state.createCompany) && <div className="corner-action-icon">
            <Button
              onClick={() => {
                this.setState({
                  myCompanyBefore: JSON.stringify(this.state.myCompany),
                  createCompany: true
                });
              }}
              color="primary"
              size="sm"
              round
              icon
              disabled={this.state.isSavingMyCompany}
            >
              <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} />
            </Button>
          </div>}
        </CardHeader>
        <CardBody>
          {content}
        </CardBody>
      </div>
    );
    return card;
  }
  createEmployeesCardContent() {
    let content = null;
    if (this.state.isLoadingMyEmployees && !this.state.myEmployees) {
      content = (
        <Col xs={12} md={12}>
          <CardTitle><i className="now-ui-icons arrows-1_refresh-69 spin" /></CardTitle>
        </Col>
      );
    } else {
      if (this.state.createEmployee || this.state.editEmployee) {
        let newEmployee = this.state.newEmployee;
        if (!newEmployee) newEmployee = {};
        let fields = [
          {
            title: "Nombre",
            name: "name",
            type: "text",
            placeholder: "María"
          },
          {
            title: "Primer apellido",
            name: "surname1",
            type: "text",
            placeholder: "García"
          },
          {
            title: "Segundo apellido",
            name: "surname2",
            type: "text",
            placeholder: "Pérez"
          },
          {
            title: "Email",
            name: "email",
            type: "email",
            placeholder: "correo@dominio.es"
          },
          {
            title: "Móvil",
            name: "mobile",
            type: "number",
            placeholder: "612345678"
          },
          {
            title: "PIN",
            name: "pin",
            type: "text",
            placeholder: "12345678A"
          }
        ];
        // let name = (newEmployee && newEmployee.name) ? newEmployee.name : "";
        // let surname1 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
        // let surname2 = (newEmployee && newEmployee.surname1) ? newEmployee.surname1 : "";
        // let email = (newEmployee && newEmployee.email) ? newEmployee.email : "";
        // let mobile = (newEmployee && newEmployee.mobile) ? newEmployee.mobile : "";
        console.log(this.state);
        content = (
          <Row className="text-left employee-info new-employee">
            <Col xs={12} md={12}>
              <CardHeader>
                <b>
                  {newEmployee.isNew ? (<span><i className="now-ui-icons ui-1_simple-add" /> Nuevo empleado</span>) : (<span><i className="fa fa-edit" /> Editar empleado</span>)}
                </b>
              </CardHeader>
            </Col>
            {fields.map(field => {
              field.value = this.state.newEmployee && this.state.newEmployee[field.name] ? this.state.newEmployee[field.name] : "";
              return (
                <Col xs={12} md={12} key={"new-employee-" + field.name}>
                  <Label md={3}>{field.title}</Label>
                  <FormGroup>
                    <Input
                      {...field}
                      onChange={event =>
                        this.handleEntityFieldChange("newEmployee", field.name, event.target.value)
                      }
                    />
                  </FormGroup>
                </Col>
              );
            })}
            <Col xs={6}>
              <Button 
                block 
                color="success" 
                size="sm"
                onClick={() => {
                  this.saveEmployee();
                  // this.setState({ createCompany: false });
                }}
                >
                Guardar
              </Button>
            </Col>
            <Col xs={6}>
              <Button 
                block 
                color="default" 
                size="sm"
                onClick={() => {
                  this.setState({
                    createEmployee: false,
                    newEmployee: null,
                    editEmployee: null
                  });
                }}
                >
                Cancelar
              </Button>
            </Col>
          </Row>
        );
      } else {
        if (this.state.myEmployees && Object.keys(this.state.myEmployees).length > 0) {
          let employees = [];
          let employeesIds = Object.keys(this.state.myEmployees);
          let size = employeesIds.length;
          // if (size > 2) {
            size = {
              xs: 12,
              md: 4,
              lg: 4,
              xl: 4
            };
          // }
          employeesIds.map(employeeId => {
            let employee = this.state.myEmployees[employeeId];
            let bodyContent = null;
            let specialColor = false;
            if (employee.isNew) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Creando</span>;
              specialColor = true;
            } else if (this.state.editingEmployee && this.state.editingEmployee[employeeId]) {
              bodyContent = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Guardando</span>;
              specialColor = true;
            } else {
              bodyContent = (
                <div className="worker-related-info">
                  <span><i className="now-ui-icons tech_mobile" /> {employee.mobile}</span><br />
                  <span><i className="now-ui-icons ui-1_email-85" /> {employee.email}</span>
                </div>
              );
            }
            let options = null;
            if (this.state.openOptionsEmployee === employeeId) {
              bodyContent = (
                <Row id="edit-workplace-buttons">
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          editEmployee: employeeId,
                          openOptionsEmployee: null,
                          newEmployee: employee
                        });
                      }}
                      color="primary"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyEmployee}
                    >
                      <i className="fa fa-edit" /> Editar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                  <Col xs={6}>
                    <Button
                      onClick={() => {
                        this.setState({
                          openOptionsEmployee: null
                        });
                      }}
                      color="danger"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isSavingMyEmployee}
                    >
                      <i className="fa fa-trash" /> Eliminar
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <br />
                    {!(this.state.learnUrls && this.state.learnUrls[employee.uuid]) && <Button
                      onClick={() => {
                        this.generateLearnUrl(employee.uuid);
                        // this.setState({
                        //   openOptionsEmployee: null
                        // });
                      }}
                      color="warning"
                      size="sm"
                      round
                      // icon
                      disabled={this.state.isGeneratingLearnUrl}
                    >
                      <i className={this.state.isGeneratingLearnUrl ? "now-ui-icons arrows-1_refresh-69 spin" : "fa arrows-1_cloud-upload-94"} /> Enlace reconocimiento
                      {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                    </Button>}
                    {(this.state.learnUrls && this.state.learnUrls[employee.uuid]) && <div>
                      <Label>Enlace reconocimiento facial</Label>
                        <FormGroup>
                          <Input
                            disabled
                            type="text"
                            name="learUrl"
                            placeholder="Enlace"
                            value={this.state.learnUrls[employee.uuid]}
                          />
                        </FormGroup></div>}
                  </Col>
                </Row>
              );
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptionsEmployee: null
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="now-ui-icons ui-1_simple-remove" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            } else {
              options = (
                <div className="corner-action-icon delete-workplace">
                  <Button
                    onClick={() => {
                      this.setState({
                        openOptionsEmployee: employeeId
                      });
                    }}
                    color="primary"
                    size="sm"
                    round
                    icon
                    // disabled={this.state.isSavingMyCompany}
                  >
                    <i className="fa fa-ellipsis-v" />
                    {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
                  </Button>
                </div>
              );
            }
            employees.push(
              <Col {...size} key={employeeId}>
                <Card className={"employee-info card-stats plain " + (specialColor ? "employee-editing" : "")}>
                  {/* <CardHeader>
                    <b>
                      <i className="fa fa-child" /> {employee.name}{" "}{employee.surname1}{" "}{employee.surname2}
                    </b>
                  </CardHeader> */}
                    <CardBody>
                      {options}
                      <div className="employee-initials-wrapper"><div className="employee-initials">{employee.name[0]}{employee.surname1[0]}</div></div>
                      <div className="worker-name">
                        <b>
                          <i className="fa fa-child" /> {employee.name}{" "}{employee.surname1}
                        </b>
                      </div>
                      {bodyContent}
                    </CardBody>
                </Card>
              </Col>
            );
          });
          content = <Row>{employees}</Row>;
        } else {
          content = (
            <Row>
              <Col xs={12} md={12}>
                No hay empleados
                <Button 
                  block 
                  color="primary" 
                  size="sm"
                  disabled={this.state.isSavingMyEmployee}
                  onClick={() => {
                    this.setState({
                      newEmployee: {
                        isNew: true
                      },
                      createEmployee: true
                    });
                  }}
                  >
                  {!this.state.isSavingMyEmployee ?
                    (<span><i className="now-ui-icons ui-1_simple-add" /> Añadir empleado</span>) :
                    (<span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Añadiendo</span>)
                  }
                </Button>
              </Col>
            </Row>
          );
        }
      }
    }
    return content;
    let card = (
      <Col xs={12}>
        <Card className="my-company-workplaces-info card-stats plain">
          <CardHeader>
            <b>
              <i className="fa fa-building" /> Centros de trabajo
            </b>
            <div className="corner-action-icon">
              <Button
                onClick={() => {
                  this.setState({
                    newWorkplace: null,
                    createWorkplace: true
                  });
                }}
                color="primary"
                size="sm"
                round
                // icon
                disabled={this.state.isSavingMyCompany}
              >
                <i className="now-ui-icons ui-1_simple-add" /> Nuevo
                {/* <i className={this.state.isSavingMyCompany ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-edit"} /> */}
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  createMyEmployeesCard() {
    let card = null;
    let content = this.createEmployeesCardContent();

    card = (
      <Col xs={12}>
        <Card id="my-employees-info" className="card-stats card-raised">
          <CardHeader>
            <b><i className="fa fa-users"></i> Mis empleados</b>
            {(this.state.myEmployees && !this.state.createEmployee) && <div className="corner-action-icon">
              <Button
                onClick={() => {
                  this.setState({
                    newEmployee:  { isNew: true },
                    createEmployee: true
                  });
                }}
                color="primary"
                size="sm"
                round
                icon
                disabled={this.state.isSavingMyEmployee}
              >
                <i className="now-ui-icons ui-1_simple-add" />
              </Button>
            </div>}
          </CardHeader>
          <CardBody>
            {content}
          </CardBody>
        </Card>
      </Col>
    );
    return card;
  }
  render() {
    // console.log("this.state", this.state);
    return (
      <div>
        <PanelHeader
          size="sm"
          content={this.createMyCompanyCard()}
        />
        <div className="content">
          <Row>
            {/* <Card>
              <CardBody>
                <Timepicker
                  onChange={(e) => console.log("timespan1 e:", e)}
                  size={300}
                  radius={90}
                />
                <Timepicker
                  onChange={(e) => console.log("timespan2 e:", e)}
                  size={250}
                  radius={80}
                />
              </CardBody>
            </Card> */}
            {/* <Timespanpicker
                outerRadius="150"
                interval="15"
                boundaryHour="20"
                onClick={(e) => console.log("timespan e:", e)}
                showResults
            /> */}
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Basic example"
                value={this.state.clock}
                onChange={(newValue) => {
                  console.log("clock newValue", newValue);
                  this.setState({ clock: newValue });
                  // setValue(newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider> */}
            {/* <Button
              color="danger"
              size="sm"
              onClick={e =>
                this.downloadXml(null, null, e)
              }
            >
              Test remesa XML
            </Button> */}
            {/* {mqttButton} */}
          </Row>
          <Row>
            {/* {this.createMyCompanyCard()} */}
            {this.buildWorkplaces()}
            {this.createMyEmployeesCard()}
          </Row>
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx